import { useContext } from "react";
import ImageColButton from "./ImageColButton";
import { useDrag } from "../hooks/useDragAndDrop";
import { Context } from "../EditorContext";

import Col_12_Icon from "../Col/Col-12-Icon";
import Col_3_9_Icon from "../Col/Col-3-9-Icon";
import Col_4_8_Icon from "../Col/Col-4-8-Icon";
import Col_6_6_Icon from "../Col/Col-6-6-Icon";
import Col_8_4_Icon from "../Col/Col-8-4-Icon";
import Col_4_4_4_Icon from "../Col/Col-4-4-4-Icon";
import Col_3_6_3_Icon from "../Col/Col-3-6-3-Icon";
import Col_6_3_3_Icon from "../Col/Col-6-3-3-Icon";
import Col_3_3_3_3_Icon from "../Col/Col-3-3-3-3-Icon";
import Col_2_2_2_2_2_2_Icon from "../Col/Col-2-2-2-2-2-2-Icon";

export default () => {
  const { shareRefs } = useContext(Context);
  const getDragRowProps = useDrag({
    onDragStart: () => {
      shareRefs.dragToNodeType = "row";
    },
    oonDragEnd: () => {
      
    },
  });

  return (
    <div style={{ margin: 16, overflow: "auto" }}>
      <ImageColButton icon={<Col_12_Icon />} {...getDragRowProps("col-12")} />
      <ImageColButton icon={<Col_3_9_Icon />} {...getDragRowProps("col-3-9")} />
      <ImageColButton icon={<Col_4_8_Icon />} {...getDragRowProps("col-4-8")} />
      <ImageColButton icon={<Col_6_6_Icon />} {...getDragRowProps("col-6-6")} />
      <ImageColButton icon={<Col_8_4_Icon />} {...getDragRowProps("col-8-4")} />
      <ImageColButton
        icon={<Col_4_4_4_Icon />}
        {...getDragRowProps("col-4-4-4")}
      />
      <ImageColButton
        icon={<Col_3_6_3_Icon />}
        {...getDragRowProps("col-3-6-3")}
      />
      <ImageColButton
        icon={<Col_6_3_3_Icon />}
        {...getDragRowProps("col-6-3-3")}
      />
      <ImageColButton
        icon={<Col_3_3_3_3_Icon />}
        {...getDragRowProps("col-3-3-3-3")}
      />
      <ImageColButton
        icon={<Col_2_2_2_2_2_2_Icon />}
        {...getDragRowProps("col-2-2-2-2-2-2")}
      />
    </div>
  );
};
